/**
 * sitemap
 * 起動設定およびサイトマップ関連の処理を行う
 */
import sitemapApi from '@/api/users/sitemapApi'
import {
  /** ページ種別定義 */
  SITEMAP_CONTENT_TYPE,
} from '@/functions/users/sitemapFunc'

/** 初回読み込み件数
 * 以下のAPIが初回読み込みAPI
 * 'sitemap/getSitemapWaitList'
 * 'sitemap/getSitemapRoboList'
 * 'sitemap/getSitemapRecruitList'
 * 'sitemap/getSitemapCustomList'
 * 'sitemap/getSitemapRecruitListAll'
 * 'sitemap/getSitemapCustomListAll'
 */
const firstLoadNum = 7

export default {
  namespaced: true,
  state: {
    /** 初回読み込み */
    isFirstLoad            : false,
    /** 初回読み込み件数カウント */
    firstLoadCount         : firstLoadNum,
    /** データ読み込み中 */
    isLoading              : false,
    /** タブインデックス */
    tabIndex               : 0,
    /** 表示中ページ番号 */
    nowPages               : 1,
    /** サイトマップ用ロボリスト */
    sitemapRoboList        : [],
    /** ホームページ用タグリスト */
    homePageTagList        : [],
    /** 求人ページ用タグリスト */
    employmentTagList      : [],
    /** 新規サイトマップ登録フラグ */
    isCreateSitemap        : false,
    /** 作成待機中マップリスト */
    sitemapWaitList        : [],
    /** 作成済みサイトマップリスト */
    sitemapRootList        : [],
    /** 求人/カスタムページリスト */
    sitemapEmploymentList  : [],
    /** 求人ページリスト */
    sitemapRecruitList     : [],
    /** 全求人ページリスト */
    sitemapRecruitListAll  : [],
    /** カスタムページリスト */
    sitemapCustomList      : [],
    /** 全カスタムページリスト */
    sitemapCustomListAll   : [],
    /** 求人コンテンツ数 */
    countRecruitPage       : 0,
    /** カスタムコンテンツ数 */
    countCustomPage        : 0,
    /** ロボ適用対象 */
    roboApplyTarget        : [],
    /** 選択中のサイトマップ */
    selectedSitemapRoot    : {},
    /** サイトマップルート編集モーダルオープンフラグ */
    isModalSitemapRootEdit : false,
    /** サイトマップノード編集モーダルオープンフラグ */
    isModalSitemapNodeEdit : false,
    /** サイトマップ適用ロボ設定モーダルオープンフラグ */
    isModalSitemapRoboApply: false,
    /** エラーフラグ */
    isError                : false,
    /** エラータイトル */
    errorTitele            : '',
    /** エラ〜メッセージ */
    errorMessage           : '',
    /** タグ候補リスト */
    searchWordsBox         : [],
    /** タグクリックフラグ */
    isClickTag             : false,
    /** クリックタグID */
    isClickId              : '',

    sitemapFlug            : true,

},
  actions: {
    //////////////////////////////////////////
    // ベース情報関連
    /**
     * サイトマップ用ロボ一覧取得
     * @param {*} param0 
     */
    getSitemapRoboList ({commit}) {
      commit('SET_FIRST_LOAD', true)
      commit('SET_LOADING', true)
      return sitemapApi.getSitemapRoboList()
        .then((response) => {
          commit('SET_SITEMAP_ROBO_LIST', response.data)
          commit('SET_FIRST_LOAD', false)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch((error) => {
          console.error('getSitemapRoboList error', error)
          commit('SET_FIRST_LOAD', false)
          commit('SET_LOADING', false)
        })
    },
    /**
     * ホームページ用タグ一覧取得
     * @param {*} param0 
     * @param {Object} selectedSitemapRoot 選択中サイトマップルート
     */
    getHomePageTagList ({commit}, selectedSitemapRoot) {
      commit('SET_LOADING', true)
      sitemapApi.getHomePageTagList(selectedSitemapRoot.pk)
        .then((response) => {
          commit('SET_HOMEPAGE_TAG_LIST', response.data)
          commit('SET_LOADING', false)
        })
        .catch((error) => {
          console.error('getHomePageTagList error', error)
          commit('SET_LOADING', false)
        })
    },
    /**
     * サイトマップ求人ページ用タグ一覧取得
     * @param {*} param0 
     */
    getEmploymentTagList ({commit}) {
      commit('SET_LOADING', true)
      sitemapApi.getEmploymentTagList()
        .then((response) => {
          commit('SET_EMPLOYMENT_TAG_LIST', response.data)
          commit('SET_LOADING', false)
        })
        .catch((error) => {
          console.error('getEmploymentTagList error', error)
          commit('SET_LOADING', false)
        })
    },
    //////////////////////////////////////////
    // サイトマップルート関連
    /**
     * 待機中サイトマップルートリスト取得
     * @param {*} param0 
     */
    getSitemapWaitList ({commit}) {
      commit('SET_FIRST_LOAD', true)
      commit('SET_LOADING', true)
      sitemapApi.getSitemapWaitList()
        .then((response) => {
          commit('SET_SITEMAP_WAIT', response.data)
          commit('SET_FIRST_LOAD', false)
          commit('SET_LOADING', false)
        })
        .catch((error) => {
          console.error('getSitemapWaitList error', error)
          commit('SET_FIRST_LOAD', false)
          commit('SET_LOADING', false)
        })
    },
    /**
     * 待機中サイトマップルート登録
     * @param {*} param0 
     * @param {String} createSitemapUrl 登録サイトマップルートURL
     */
    registSitemapWait ({commit}, createSitemapUrl) {
      commit('SET_CREATEING', true)
      sitemapApi.registSitemapWait(createSitemapUrl)
        .then((response) => {
          commit('SET_CREATEING', false)
          if (response.data.warning && response.data.message) {
            if (response.data.warning === 'url-waiting') {
              // ノード重複エラー
              const errer_info = {
                title  : 'URL重複エラー',
                message: response.data.message + '\nは登録待機中のURLです。'
              }
              commit('SET_ERROR', errer_info)
            } else if (response.data.warning === 'url-exist') {
              // ノード重複エラー
              const errer_info = {
                title  : 'URL重複エラー',
                message: response.data.message + '\nは既に存在するURLです。'
              }
              commit('SET_ERROR', errer_info)
            } else if (response.data.warning === 'url-not-found') {
              // ノードURLリンクエラー
              const errer_info = {
                title  : 'URLリングエラー',
                message: response.data.message + '\nのページが見つかりませんでした。'
              }
              commit('SET_ERROR', errer_info)
            }
          } else {
            commit('SET_SITEMAP_WAIT', response.data)
          }
          commit('SET_CREATEING', false)
        })
        .catch((error) => {
          console.error('registSitemapWait error', error)
          const errer_info = {
            title  : '登録エラー',
            message: 'サイトマップの登録に失敗しました。'
          }
          commit('SET_ERROR', errer_info)
          commit('SET_CREATEING', false)
        })
    },
    /**
     * 待機中サイトマップルート削除
     * @param {*} param0 
     * @param {Object} deleteSitemapWait 削除待機中サイトマップルートPK
     * 削除待機中サイトマップルートPK
     * {
     *   sitemap_wait_pk: <待機中サイトマップルートのPK>
     * }
     */
    deleteSitemapWait ({commit}, deleteSitemapWait) {
      sitemapApi.deleteSitemapWait(deleteSitemapWait)
        .then((response) => {
          commit('SET_SITEMAP_WAIT', response.data)
        })
        .catch((error) => {
          console.error('deleteSitemapWait error', error)
          const errer_info = {
            title  : '削除エラー',
            message: '待機中サイトマップの削除に失敗しました。'
          }
          commit('SET_ERROR', errer_info)
        })
    },
    /**
     * サイトマップルートリスト取得
     * @param {*} param0 
     */
    getSitemapRootList ({commit}) {
      commit('SET_FIRST_LOAD', true)
      return sitemapApi.getSitemapRootList()
        .then((response) => {
          commit('SET_SITEMAP_ROOT', response.data)
          commit('SET_FIRST_LOAD', false)
          return response.data
        })
        .catch((error) => {
          console.error('getSitemapRootList error', error)
          const errer_info = {
            title  : '読み込みエラー',
            message: 'サイトマップの読み込みに失敗しました。'
          }
          commit('SET_ERROR', errer_info)
          commit('SET_FIRST_LOAD', false)
        })
    },
    /**
     * サイトマップルート削除
     * @param {*} param0 
     * @param {Object} deleteSitemapRoot 削除サイトマップルートPK
     * 削除サイトマップルートPK
     * {
     *   sitemap_root_pk: <サイトマップルートのPK>
     * }
     */
    deleteSitemapRoot ({commit}, deleteSitemapRoot) {
      sitemapApi.deleteSitemapRoot(deleteSitemapRoot)
        .then((response) => {
          commit('SET_SITEMAP_ROOT', response.data)
        })
        .catch((error) => {
          console.error('deleteSitemapRoot error', error)
          const errer_info = {
            title  : '読み込みエラー',
            message: 'サイトマップの読み込みに失敗しました。'
          }
          commit('SET_ERROR', errer_info)
        })
    },
    //////////////////////////////////////////
    // サイトマップノード関連
    /**
     * サイトマップノード追加
     * @param {*} param0 
     * @param {Object} addNodeData 追加サイトマップノード情報
     * 追加サイトマップノード情報
     * {
     *   sitemap_root: <サイトマップルートのオブジェクト>,
     *   add_node    : <追加ノードのパス(ルートURLを除く)>
     * }
     */
    addSitemapNode ({commit}, addNodeData) {
      commit('SET_LOADING', true)
      sitemapApi.addSitemapNode(addNodeData)
        .then((response) => {
          if (response.data.warning && response.data.message) {
            if (response.data.warning === 'url-exist') {
              // ノード重複エラー
              console.warn('URL dupricate error')
              const errer_info = {
                title  : 'URL重複エラー',
                message: response.data.message + '\nは既に存在するURLです。'
              }
              commit('SET_ERROR', errer_info)
            } else if (response.data.warning === 'url-not-found') {
              // ノードURLリンクエラー
              console.warn('URL link error')
              const errer_info = {
                title  : 'URLリンクエラー',
                message: response.data.message + '\nのページが見つかりませんでした。'
              }
              commit('SET_ERROR', errer_info)
            }
          } else {
            commit('SET_SITEMAP_ROOT', response.data)
          }
          commit('SET_LOADING', false)
          return response.data
        })
        .catch((error) => {
          console.error('addSitemapNode error', error)
          const errer_info = {
            title  : '読み込みエラー',
            message: 'サイトマップの読み込みに失敗しました。'
          }
          commit('SET_ERROR', errer_info)
          commit('SET_LOADING', false)
        })
    },
    /**
     * サイトマップノード更新
     * @param {*} param0 
     * @param {Object} updateData 更新サイトマップノード情報
     * 更新サイトマップノード情報
     * {
     *   update_list: <更新情報>,
     *   action     : <更新種別>,
     *   is_mini    : <メインロボ：false、ミニロボ：True>
     * }
     * 
     * 更新種別
     * action
     * 'start-robo'   : 初回起動ロボ設定
     * 'robo-apply'   : 適用ロボ設定
     * 'robo-unapply' : 適用ロボ除外設定
     * 'edit-node'    : サイトマップノード編集
     * 
     * 更新情報(起動設定の場合はlist、初回起動設定の場合は非list)
     * {
     *   target: <更新先サイトマップ(ホームページ)>,
     *   robo  : <サイトマップ用ロボオブジェクト>
     * }
     */
    updateSitemapNode ({commit}, updateData) {
      commit('SET_LOADING', true)
      return sitemapApi.updateSitemapNode(updateData)
        .then((response) => {
          if (response.data.warning && response.data.message) {
            if (response.data.warning === 'url-exist') {
              // ノード重複エラー
              console.warn('URL dupricate error')
              const errer_info = {
                title  : 'URL重複エラー',
                message: response.data.message + '\nは既に存在するURLです。'
              }
              commit('SET_ERROR', errer_info)
            } else if (response.data.warning === 'url-not-found') {
              // ノードURLリンクエラー
              console.warn('URL link error')
              const errer_info = {
                title  : 'URLリンクエラー',
                message: response.data.message + '\nのページが見つかりませんでした。'
              }
              commit('SET_ERROR', errer_info)
            } else if (response.data.warning === 'action-not-found') {
              // 更新操作エラー
              console.warn('Update operation error')
              const errer_info = {
                title  : '操作エラー',
                message: response.data.message + '\n無効な操作が行われました。'
              }
              commit('SET_ERROR', errer_info)
            } else {
              // 不明なエラー
              console.error('Unknown error')
              const errer_info = {
                title  : '不明なエラー',
                message: '原因不明のエラーが発生しました。'
              }
              commit('SET_ERROR', errer_info)
            }
          } else {
            // 更新正常終了
            commit('SET_SITEMAP_ROOT', response.data)
            commit('SET_LOADING', false)
            return response.data
          }
          commit('SET_LOADING', false)
        })
        .catch((error) => {
          console.error('updateSitemapNode error', error)
          commit('SET_LOADING', false)
          const errer_info = {
            title  : '起動設定エラー',
            message: 'ロボの起動設定に失敗しました。'
          }
          commit('SET_ERROR', errer_info)
          return 
        })
    },
    /**
     * サイトマップノード削除
     * @param {*} param0 
     * @param {Object} deleteNodeData 削除サイトマップノード情報
     * 削除サイトマップノード情報
     * {
     *   node_pk: <サイトマップノードPK>
     * }
     */
    deleteSitemapNode ({commit}, deleteNodeData) {
      commit('SET_LOADING', true)
      sitemapApi.deleteSitemapNode(deleteNodeData)
        .then((response) => {
          commit('SET_SITEMAP_ROOT', response.data)
          commit('SET_LOADING', false)
        })
        .catch((error) => {
          console.error('deleteSitemapNode error', error)
          const errer_info = {
            title  : '削除エラー',
            message: 'パスの削除に失敗しました。'
          }
          commit('SET_ERROR', errer_info)
          commit('SET_LOADING', false)
        })
    },
    //////////////////////////////////////////
    // サイトマップ求人ページ関連
    /**
     * 求人ページリスト取得
     * @param {*} param0 
     * @param {Object} getEmploymentPageData 取得ページ情報
     * 取得ページ情報
     * {
     *   pages  : <取得ページ番号>,
     *   perPage: <1ページ表示件数>
     * }
     */
    getSitemapEmploymentListAll ({commit}) {
      commit('SET_LOADING', true)
      return sitemapApi.getSitemapEmploymentListAll()
        .then((response) => {
          commit('SET_EMPLOYMENT_PAGE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch((error) => {
          console.error('getSitemapEmploymentListAll error', error)
          commit('SET_LOADING', false)
          return
        })
    },
    /**
     * 求人ページリスト取得
     * @param {*} param0 
     * @param {Object} getEmploymentPageData 取得ページ情報
     * 取得ページ情報
     * {
     *   pages  : <取得ページ番号>,
     *   perPage: <1ページ表示件数>
     * }
     */
    getSitemapRecruitList ({commit}, getEmploymentPageData) {
      commit('SET_FIRST_LOAD', true)
      commit('SET_LOADING', true)
      return sitemapApi.getSitemapRecruitList(getEmploymentPageData)
        .then((response) => {
          commit('SET_RECRUIT_PAGE', response.data)
          commit('SET_FIRST_LOAD', false)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch((error) => {
          console.error('getSitemapRecruitList error', error)
          commit('SET_FIRST_LOAD', false)
          commit('SET_LOADING', false)
          return
        })
    },
    /**
     * 全求人ページリスト取得
     * @param {*} param0 
     */
    getSitemapRecruitListAll ({commit}) {
      commit('SET_FIRST_LOAD', true)
      commit('SET_LOADING', true)
      return sitemapApi.getSitemapRecruitListAll(SITEMAP_CONTENT_TYPE.RECRUIT_PAGE)
        .then((response) => {
          commit('SET_RECRUIT_ALLPAGE', response.data)
          commit('SET_FIRST_LOAD', false)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch((error) => {
          console.error('getSitemapRecruitListAll error', error)
          commit('SET_FIRST_LOAD', false)
          commit('SET_LOADING', false)
          return
        })
    },
    /**
     * カスタムページリスト取得
     * @param {*} param0 
     * @param {Object} getEmploymentPageData 取得ページ情報
     * 取得ページ情報
     * {
     *   pages  : <取得ページ番号>,
     *   perPage: <1ページ表示件数>
     * }
     */
    getSitemapCustomList ({commit}, getEmploymentPageData) {
      commit('SET_FIRST_LOAD', true)
      commit('SET_LOADING', true)
      return sitemapApi.getSitemapCustomList(getEmploymentPageData)
        .then((response) => {
          commit('SET_CUSTOM_PAGE', response.data)
          commit('SET_FIRST_LOAD', false)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch((error) => {
          console.error('getSitemapCustomList error', error)
          commit('SET_FIRST_LOAD', false)
          commit('SET_LOADING', false)
          return
        })
    },
    /**
     * 全カスタムページリスト取得
     * @param {*} param0 
     */
    getSitemapCustomListAll ({commit}) {
      commit('SET_FIRST_LOAD', true)
      commit('SET_LOADING', true)
      return sitemapApi.getSitemapCustomListAll(SITEMAP_CONTENT_TYPE.CUSTOM_PAGE)
        .then((response) => {
          commit('SET_CUSTOM_ALLPAGE', response.data)
          commit('SET_FIRST_LOAD', false)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch((error) => {
          console.error('getSitemapCustomListAll error', error)
          commit('SET_FIRST_LOAD', false)
          commit('SET_LOADING', false)
          return
        })
    },
    /**
     * 求人ページリスト更新
     * @param {*} param0 
     * @param {Object} updateData 更新サイトマップ求人ページ情報
     * @param {Object} pageData 取得ページ情報
     * 更新サイトマップ求人ページ情報
     * const updateData = {
     *   update_list: <更新情報>,
     *   action     : <更新種別>,
     *   is_mini    : <メインロボ：false、ミニロボ：True>
     * }
     * 
     * 更新種別
     * action
     * 'start-robo'   : 初回起動ロボ設定
     * 'robo-apply'   : 適用ロボ設定
     * 'robo-unapply' : 適用ロボ除外設定
     * 
     * 更新情報(起動設定の場合はlist、初回起動設定の場合は非list)
     * {
     *   target: <更新先サイトマップ(求人ページ、カスタムページ両用)>,
     *   robo  : <サイトマップ用ロボオブジェクト>
     * }
     * 
     * 取得ページ情報
     * {
     *   pages  : <取得ページ番号>,
     *   perPage: <1ページ表示件数>
     * }
     */
    updateSitemapEmployment ({commit}, updateData) {
      commit('SET_LOADING', true)
      return sitemapApi.updateSitemapEmployment(updateData)
        .then((response) => {
          if (updateData.page_data === undefined) {
            // 求人ページおよびカスタムページ
            commit('SET_EMPLOYMENT_PAGE', response.data)
          } else if (updateData.page_data.content_type === SITEMAP_CONTENT_TYPE.RECRUIT_PAGE) {
            // 求人ページ
            if (updateData.page_data.pages === 0) {
              commit('SET_RECRUIT_ALLPAGE', response.data)
            } else {
              commit('SET_RECRUIT_PAGE', response.data)
            }
          } else if (updateData.page_data.content_type === SITEMAP_CONTENT_TYPE.CUSTOM_PAGE) {
            // カスタムページ
            commit('SET_CUSTOM_PAGE', response.data)
          }
          commit('SET_LOADING', false)
          return response.data
        })
        .catch((error) => {
          commit('SET_LOADING', false)
          const errer_info = {
            title  : '起動設定エラー',
            message: 'ロボの起動設定に失敗しました。'
          }
          commit('SET_ERROR', errer_info)
          return
        })
    },
    async updateSitemapEmploymentSync ({commit}, updateData) {
      // 同期処理用
      commit('SET_LOADING', true)
      return await sitemapApi.updateSitemapEmployment(updateData)
        .then((response) => {
          if (updateData.page_data === undefined) {
            // 求人ページおよびカスタムページ
            commit('SET_EMPLOYMENT_PAGE', response.data)
          } else if (updateData.page_data.content_type === SITEMAP_CONTENT_TYPE.RECRUIT_PAGE) {
            // 求人ページ
            if (updateData.page_data.pages === 0) {
              commit('SET_RECRUIT_ALLPAGE', response.data)
            } else {
              commit('SET_RECRUIT_PAGE', response.data)
            }
          } else if (updateData.page_data.content_type === SITEMAP_CONTENT_TYPE.CUSTOM_PAGE) {
            // カスタムページ
            commit('SET_CUSTOM_PAGE', response.data)
          }
          commit('SET_LOADING', false)
          return response.data
        })
        .catch((error) => {
          commit('SET_LOADING', false)
          const errer_info = {
            title  : '起動設定エラー',
            message: 'ロボの起動設定に失敗しました。'
          }
          commit('SET_ERROR', errer_info)
          return
        })
    },
    //////////////////////////////////////////
    // ロボ表示順関連
    /**
     * ロボ表示順取得
     * @param {*} param0 
     */
    getSitemapRoboOrder ({commit}) {
      commit('SET_LOADING', true)
      return sitemapApi.getSitemapRoboOrder()
        .then((response) => {
          commit('SET_LOADING', false)
          return response.data
        })
        .catch((error) => {
          console.error('getSitemapRoboOrder error', error)
          commit('SET_LOADING', false)
          return
        })
    },
    /**
     * ロボ表示順更新
     * @param {*} param0 
     */
    updateSitemapRoboOrder ({commit}, roboOrder) {
      sitemapApi.updateSitemapRoboOrder(roboOrder)
        .catch((error) => {
          console.error('updateSitemapRoboOrder error', error)
        })
    },
    //////////////////////////////////////////
    // タグ関連
    /**
     * タグ更新
     * @param {*} param0 
     * @param {Object} addTagData 追加タグ情報
     * 追加タグ情報
     * {
     *   sitemap_pk  : <対象サイトマップPK>,
     *   add_tag_name: <追加タグ名>,
     *   is_recruit  : <求人ページおよびカスタマイズページフラグ>,
     * }
     */
    addSitemapTag ({commit}, addTagData) {
      return sitemapApi.addSitemapTag(addTagData)
        .then((response) => {
          if (response.data.warning && response.data.message) {
            if (response.data.warning === 'tag-duplication') {
              // タグ重複エラー
              const errer_info = {
                title  : 'タグ重複エラー',
                message: '「' + response.data.message + '」は既に存在するタグ名です。'
              }
              commit('SET_ERROR', errer_info)
            }
          } else {
            if (addTagData.is_recruit === true) {
              if (addTagData.content_type === SITEMAP_CONTENT_TYPE.RECRUIT_PAGE) {
                commit('SET_RECRUIT_PAGE', response.data)
              } else {
                commit('SET_CUSTOM_PAGE', response.data)
              }
            } else {
              commit('SET_SITEMAP_ROOT', response.data)
            }
          }
          return
        })
        .catch((error) => {
          console.error('addSitemapTag error', error)
          return
        })
    },
    /**
     * タグ削除
     * @param {*} param0 
     * @param {Object} sendData 削除タグ情報
     */
    deleteSitemapTag ({commit}, sendData) {
      sitemapApi.deleteSitemapTag(sendData)
        .then((response) => {
          if (sendData.is_str_recruit === 'true') {
            if (sendData.content_type === SITEMAP_CONTENT_TYPE.RECRUIT_PAGE) {
              commit('SET_RECRUIT_PAGE', response.data)
            } else {
              commit('SET_CUSTOM_PAGE', response.data)
            }
          } else {
            commit('SET_SITEMAP_ROOT', response.data)
          }
        })
        .catch((error) => {
          console.error('deleteSitemapTag error', error)
        })
    },
    /**
     * サイトマップタグ一括編集
     * @param {*} param0 
     * @param {Object} sendData 一括タグ編集データ
     */
    editAllSitemapTag ({commit}, sendData) {
      return sitemapApi.editAllSitemapTag(sendData)
        .then((response) => {
          if (response.data.warning && response.data.message) {
            if (response.data.warning === 'tag-duplication') {
              // タグ重複エラー
              const errer_info = {
                title  : 'タグ重複エラー',
                message: '「' + response.data.message + '」は既に存在するタグ名です。'
              }
              commit('SET_ERROR', errer_info)
            }
          } else {
            if (sendData.is_recruit === true) {
              if (sendData.content_type === SITEMAP_CONTENT_TYPE.RECRUIT_PAGE) {
                commit('SET_RECRUIT_PAGE', response.data)
              } else {
                commit('SET_CUSTOM_PAGE', response.data)
              }
            } else {
              commit('SET_SITEMAP_ROOT', response.data)
            }
          }
          return
        })
        .catch((error) => {
          console.error('editAllSitemapTag error', error)
          return
        })
    },
    //////////////////////////////////////////
    // 制御関連
    /**
     * 表示中ページ設定
     * @param {*} param0 
     * @param {Number} nowPages 
     */
    setNowPages ({commit}, nowPages) {
      // 選択サイトマップ設定
      commit('SET_NOW_PAGES', nowPages)
    },
    /**
     * 初回読み込みフラグ更新
     * @param {*} param0 
     * @param {Boolean} flag 初回読み込みフラグ(非初回：false、初回：true)
     */
    setSelectSitemapRoot ({commit}, selectedSitemapRoot) {
      // 選択サイトマップ設定
      commit('SET_SELECT_SITEMAP_ROOT', selectedSitemapRoot)
    },
    /**
     * エラー情報クリア
     * @param {*} param0 
     */
    resetError ({commit}) {
      commit('RESET_ERROR')
    }
  },
  mutations: {
    //////////////////////////////////////////
    // ベース情報関連
    /**
     * サイトマップ用ロボ一覧取得
     * @param {*} state 
     * @param {Object} data 
     */
    SET_SITEMAP_ROBO_LIST (state, data) {
      state.sitemapRoboList = data.sitemap_robo_list
    },
    //////////////////////////////////////////
    // サイトマップ関連
    /**
     * 待機中サイトマップルートリスト取得
     * @param {*} state 
     * @param {Object} data 
     */
    SET_SITEMAP_WAIT (state, data) {
      state.sitemapWaitList = data.sitemap_wait_list
    },
    /**
     * サイトマップルートリスト取得
     * @param {*} state 
     * @param {Object} data 
     */
    SET_SITEMAP_ROOT (state, data) {
      state.sitemapRootList = data.sitemap_root_list,
      state.sitemapFlug = false
    },
    //////////////////////////////////////////
    // 求人ページ関連
    /**
     * 求人ページリスト取得
     * @param {*} state 
     * @param {Object} data 
     */
    SET_EMPLOYMENT_PAGE (state, data) {
      state.sitemapEmploymentList = data.sitemap_employment_list
      state.countEmployment       = data.total_count
    },
    /**
     * 求人ページリスト取得
     * @param {*} state 
     * @param {Object} data 
     */
    SET_RECRUIT_PAGE (state, data) {
      state.sitemapRecruitList = data.sitemap_employment_list
      state.countRecruitPage   = data.total_count
    },
    /**
     * 全求人ページリスト取得
     * @param {*} state 
     * @param {Object} data 
     */
    SET_RECRUIT_ALLPAGE (state, data) {
      state.sitemapRecruitListAll = data.sitemap_employment_list
    },
    /**
     * カスタムページリスト取得
     * @param {*} state 
     * @param {Object} data 
     */
    SET_CUSTOM_PAGE (state, data) {
      state.sitemapCustomList = data.sitemap_employment_list
      state.countCustomPage   = data.total_count
    },
    /**
     * 全カスタムページリスト取得
     * @param {*} state 
     * @param {Object} data 
     */
    SET_CUSTOM_ALLPAGE (state, data) {
      state.sitemapCustomListAll = data.sitemap_employment_list
    },
    //////////////////////////////////////////
    // タグ関連
    /**
     * 求人ページ用タグ一覧取得
     * @param {*} state 
     * @param {Object} data 
     */
    SET_EMPLOYMENT_TAG_LIST (state, data) {
      state.recruitTagList = data.recruit_tag_list
      state.customTagList  = data.custom_tag_list
    },
    /**
     * ホームページ用タグ一覧取得
     * @param {*} state 
     * @param {Object} data 
     */
    SET_HOMEPAGE_TAG_LIST (state, data) {
      state.homePageTagList = data.homepage_tag_list
    },
    //////////////////////////////////////////
    // 制御関連
    SET_NOW_PAGES (state, nowPages) {
      state.nowPages = nowPages
    },
    /**
     * 初回読み込みフラグ更新
     * @param {*} state 
     * @param {Boolean} flag 
     */
    SET_FIRST_LOAD (state, flag) {
      if (flag) {
        // trueは無条件に代入する
        state.isFirstLoad = flag
      }
      if (!flag) {
        // 読み込み終了件数を減算
        state.firstLoadCount--
        if (state.firstLoadCount <= 0) {
          // 減算が完了したら読み込み完了フラグをセットする
          state.isFirstLoad = flag
        }
      }
    },
    /**
     * 読み込み中フラグ更新
     * @param {*} state 
     * @param {Boolean} flag 
     */
    SET_LOADING (state, flag) {
      state.isLoading = flag
    },
    /**
     * 新規サイトマップ登録フラグ更新
     * @param {*} state 
     * @param {Boolean} flag 
     */
    SET_CREATEING (state, flag) {
      state.isCreateSitemap = flag
    },
    /**
     * 選択サイトマップ設定
     * @param {*} state 
     * @param {Object} selectedSitemapRoot 
     */
    SET_SELECT_SITEMAP_ROOT (state, selectedSitemapRoot) {
      state.selectedSitemapRoot = selectedSitemapRoot
    },
    //////////////////////////////////////////
    // エラー制御関連
    /**
     * エラー情報設定
     * @param {*} state 
     * @param {Object} errer_info 
     */
    SET_ERROR (state, errer_info) {
      state.isError      = true
      state.errorTitele  = errer_info.title
      state.errorMessage = errer_info.message
    },
    /**
     * エラー情報クリア
     * @param {*} state 
     */
    RESET_ERROR (state) {
      state.isError      = false
      state.errorTitele  = ''
      state.errorMessage = ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/users/sitemap.js